"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToastQueue = void 0;
var _react = require("react");
var _useTimer = require("../hooks/useTimer");
const useToastQueue = () => {
  const _useState = (0, _react.useState)(),
    activeToast = _useState[0],
    setActiveToast = _useState[1];
  const toastQueue = (0, _react.useRef)([]);
  const activeToastRef = (0, _react.useRef)(null);
  const hasActiveToast = (0, _react.useRef)(false);
  const timer = (0, _useTimer.useTimer)();
  hasActiveToast.current = !!activeToast;
  const hideToast = (0, _react.useCallback)(async () => {
    var _activeToastRef$curre;
    return (_activeToastRef$curre = activeToastRef.current) === null || _activeToastRef$curre === void 0 ? void 0 : _activeToastRef$curre.hide();
  }, [activeToastRef]);
  const removeToast = (0, _react.useCallback)(() => {
    timer.clear();
    setActiveToast(undefined);
  }, [timer, setActiveToast]);
  const setToast = (0, _react.useCallback)(toast => {
    if (!toast) return;
    activeToastRef.current = null;
    setActiveToast(Object.assign({}, toast, {
      element: /*#__PURE__*/(0, _react.cloneElement)(toast.element, {
        ref: activeToastRef
      })
    }));

    // remove toast after duration
    timer.start(() => {
      void hideToast();
    }, toast.duration);
  }, [timer, hideToast]);
  const addToast = (0, _react.useCallback)((element, duration) => {
    const toast = {
      element,
      duration
    };
    if (hasActiveToast.current) {
      toastQueue.current.push(toast);
    } else {
      setToast(toast);
    }
  }, [setToast]);
  (0, _react.useEffect)(() => {
    // dequeue toast to active
    if (activeToast === undefined && toastQueue.current.length > 0) {
      setToast(toastQueue.current.shift());
    }
  }, [activeToast, setToast]);
  const clearToastQueue = (0, _react.useCallback)(async () => {
    removeToast();
    toastQueue.current.length = 0;
  }, [removeToast]);
  return {
    activeToast,
    addToast,
    removeToast,
    hideToast,
    clearToastQueue,
    pauseTimer: timer.pause,
    resumeTimer: timer.resume
  };
};
exports.useToastQueue = useToastQueue;